import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getPurchaseOrderById } from "../../apis/purchaseorder";
import { format } from "date-fns";

const ViewPurchaseOrder = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState<any>(null);

  useEffect(() => {
    if (!id) return;
    fetchOrder();
  }, [id]);

  const fetchOrder = async () => {
    if (!id) return;
    try {
      const res: any = await getPurchaseOrderById(Number(id));
      console.log("ORDER 👉", res.data);
      setOrder(res.data);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-[60vh]">
        <span className="text-gray-500 text-sm">Loading...</span>
      </div>
    );
  }

  return (
    <div className="px-6 py-4">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-lg font-semibold">View Purchase Order</h1>
        <button
          onClick={() => navigate(-1)}
          className="px-3 py-1.5 text-sm border rounded bg-white hover:bg-gray-100"
        >
          Back
        </button>
      </div>

      {/* Purchase Order Details */}
      <div className="border rounded-lg p-4 bg-white">
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <p className="text-gray-500">PO Number -</p>
            <p className="font-medium">{order?.poNumber}</p>
          </div>

          <div>
            <p className="text-gray-500">Supplier -</p>
            <p className="font-medium">{order?.supplier?.name}</p>
          </div>

          <div>
            <p className="text-gray-500">Order Date -</p>
            <p className="font-medium">
              {order?.orderDate
                ? format(new Date(order.orderDate), "dd MMM yyyy")
                : "-"}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Total Amount -</p>
            <p className="font-medium">{order?.totalAmount}</p>
          </div>
        </div>
      </div>

      {/* Items */}
      <div className="mt-6 border rounded-lg overflow-hidden">
        <h2 className="px-4 py-2 font-semibold bg-gray-50">Items</h2>
        <table className="min-w-full text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="border px-3 py-2 text-left">Item</th>
              <th className="border px-3 py-2 text-center">Qty</th>
              <th className="border px-3 py-2 text-right">Price</th>
              <th className="border px-3 py-2 text-right">Total</th>
            </tr>
          </thead>
                  <tbody>
                      {order?.items?.map((item: any) => (
                          <tr key={item.id} className="bg-white hover:bg-gray-50">
                              <td className="border px-3 py-2">
                                  {item.pharmacyItem?.name}
                              </td>

                              <td className="border px-3 py-2 text-center">
                                  {item.quantityOrdered}
                              </td>

                              <td className="border px-3 py-2 text-right">
                                  {item.unitPrice}
                              </td>

                              <td className="border px-3 py-2 text-right">
                                  {item.totalAmount}
                              </td>
                          </tr>
                      ))}
                  </tbody>
        </table>
      </div>
    </div>
  );
};

export default ViewPurchaseOrder;
